import { useAuth0 } from '@auth0/auth0-react';
import { useMatch, useNavigate } from 'react-router-dom';

import { routes } from '~/shared/config/routes';
import { useAuthStore } from '~/shared/model/auth';

export function useLogout() {
  const logout = useAuthStore((state) => state.logout);

  const { logout: auth0Logout } = useAuth0();

  const navigate = useNavigate();

  const isHomePage = useMatch({
    path: routes.home.get(),
    end: true,
  });

  const handleLogout = async () => {
    if (!isHomePage) navigate(routes.home.get());

    logout();

    useAuthStore.persist.clearStorage();

    await auth0Logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return { handleLogout };
}
